export enum PointTypes {
  DefaultPointType = 'defaultPoint',
  EarthmovingPointType = 'earthmovingPoint'
}